import { render } from "./AddressDetailPanel.vue?vue&type=template&id=42ba4c11&scoped=true&ts=true"
import script from "./AddressDetailPanel.vue?vue&type=script&lang=ts"
export * from "./AddressDetailPanel.vue?vue&type=script&lang=ts"

import "./AddressDetailPanel.vue?vue&type=style&index=0&id=42ba4c11&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ba4c11"]])

export default __exports__